import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout, Modal, Button, Input } from 'antd';
import Toolbar from 'components/Toolbar';
import SearchBar from 'components/SearchBar';
import DataTable from 'components/DataTable';
import $$ from 'cmn-utils';
import isEqual from 'react-fast-compare';
const Pagination = DataTable.Pagination;
const { Content, Header } = Layout;

/**
 *  formItem: {
      type: 'table',
      rowKey: 'id',
      destroyOnClose: true,
      titleKey: 'name',
      dataSource,
      columns: innerColumns,
      selectType: 'radio',
      onSubmit: (form, value) => {},
      onSearch: (values) => {},
      loadData: self.onLoadTableData,
      initialValue: [11, 3, 5],
    }
 */
class TableControlled extends Component {
  static propTypes = {
    value: PropTypes.array,
    dataSource: PropTypes.object,
    onChange: PropTypes.func
  };

  static defaultProps = {
    rowKey: 'id',
    titleKey: 'title',
    modal: {}
  };

  constructor(props) {
    super(props);
    const { value, dataSource } = props;
    this.state = {
      value: value,
      selectedRowKeys: value,
      dataSource: dataSource,
      visible: false,
      loading: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { dataSource, value } = nextProps;
    if (
      !isEqual(this.props.dataSource, dataSource) ||
      !isEqual(this.props.value, value)
    ) {
      this.setState({
        dataSource: dataSource,
        value: value
      });
    }
  }

  onSelect = (keys, rows) => {
    this.setState({ selectedRowKeys: keys });
  };

  onSearch = (values) => {
    this.setState({ selectedRowKeys: [] });
    const onSearch = this.props.onSearch;
    if (onSearch) {
      onSearch(values);
    }
  };

  async onChange({ pageNum, pageSize }) {
    const loadData = this.props.loadData;
    if (loadData) {
      this.setState({
        loading: true
      });

      let dataSource = await loadData(this.props.dataSource.filters, { pageNum, pageSize });
      if(!dataSource){
        dataSource = this.props.dataSource;
      }
      dataSource.jumpPage(pageNum, pageSize);

      this.setState({
        loading: false,
        dataSource
      });
    }
  }

  onReset = () => {
    let dataSource = this.props.dataSource;
    if(dataSource){
      dataSource.jumpPage(1, 10);
    }
    
    this.onSearch({})
  }
  showModal = () => {
    this.setState({
      visible: true
    });
    this.onReset();
  };

  hideModal = () => {
    this.setState({
      visible: false
    });
  };
  
  onSubmit = () => {
    this.setState({
      visible: false
    })

    const { onSubmit, form } = this.props;
    const { selectedRowKeys } = this.state;
    if (onSubmit) {
      this.setState({ value: selectedRowKeys })
      onSubmit(form, selectedRowKeys);
    }
  };

  render() {
    const {
      modal,
      columns,
      titleKey,
      rowKey,
      selectType,
      showNum,
      size,
      onSearch,
      destroyOnClose,
      ...otherProps
    } = this.props;
    const { dataSource, value, selectedRowKeys, loading } = this.state;
    const searchBarProps = {
      columns,
      size,
      onSearch: (values) => {
        this.onSearch(values);
      },
    }
    const dataTableProps = {
      loading,
      columns,
      rowKey,
      size,
      dataItems: dataSource,
      selectedRowKeys: selectedRowKeys,
      selectType: typeof selectType === 'undefined' ? 'checkbox' : selectType,
      showNum,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => this.onChange({ pageNum, pageSize }),
      onSelect: (keys, rows) => this.onSelect(keys, rows),
    };

    const comp = 
      <Layout>
        <Header>
          <Toolbar>
            <SearchBar {...searchBarProps} />
          </Toolbar>
        </Header>
        <Content>
          <DataTable {...dataTableProps} />
        </Content>
      </Layout>
    ;
    if (modal) {
      return (
        <div>
          <Input onClick={this.showModal} style={{ cursor: 'pointer' }} placeholder={'请选择' + otherProps.title} value={value} readOnly/>
          <Modal
            className="antui-table-modal"
            title={'请选择' + otherProps.title}
            visible={this.state && this.state.visible}
            width={modal.width || 600}
            destroyOnClose={destroyOnClose}
            onSubmit={this.onSubmit}
            onCancel={this.hideModal}
            footer={[
              <Pagination
                key="paging"
                showSizeChanger={false}
                showQuickJumper={false}
                {...dataTableProps}
              />,
              <Button key="back" onClick={this.hideModal}>
                取消
              </Button>,
              <Button key="submit" type="primary" onClick={this.onSubmit}>
                确定
              </Button>
            ]}
            {...modal}
          >
            {comp}
          </Modal>
        </div>
      );
    }

    return comp;
  }
}

/**
 * TableForm组件
 */
export default ({
  form,
  name,
  dict,
  formFieldOptions = {},
  record,
  initialValue,
  rules,
  onChange,
  dataSource,
  normalize,
  ...otherProps
}) => {
  const { getFieldDecorator } = form;

  let initval = initialValue;

  if (record && name) {
    let nameArray = name.split(".");
    let generateInitVal = record;
    nameArray.forEach(function(value,key,arr){　　//值，索引，数组（默认为选定数组）
      if(generateInitVal)
      generateInitVal = generateInitVal[value];
    });
    
    initval = generateInitVal;
  }
  
  // 如果存在初始值
  if (initval !== null && typeof initval !== 'undefined') {
    if ($$.isFunction(normalize)) {
      formFieldOptions.initialValue = normalize(initval);
    } else {
      formFieldOptions.initialValue = initval;
    }
  }

  // 如果有rules
  if (rules && rules.length) {
    formFieldOptions.rules = rules;
  }

  // 如果需要onChange
  if (typeof onChange === 'function') {
    formFieldOptions.onChange = (value, rows) => onChange(form, value, rows); // form, value
  }

  return getFieldDecorator(name, formFieldOptions)(
    <TableControlled dataSource={dataSource} {...otherProps} form={form} />
  );
};



// WEBPACK FOOTER //
// ./src/components/Form/TableForm.js